import React from 'react';
import './PosePreloader.css';

function PosePreloader({ progress, statusText, title, hint }) {
  return (
    <div className="pose-preloader">
      <div className="preloader-content">
        <img className="preloader-logo" src="/img/logo.png" alt="Logo" />
        <h2 className="preloader-title">{title || 'PREPARANDO'}</h2>
        <div className="preloader-bar-container">
          <div className="preloader-bar-fill" style={{ width: `${progress}%` }} />
        </div>
        <div className="preloader-percent">{Math.round(progress)}%</div>
        <div className="preloader-status">{statusText}</div>
        {hint && <div className="preloader-hint">{hint}</div>}
      </div>
    </div>
  );
}

export default PosePreloader;
